import {Component, Directive, ElementRef, HostListener, Injectable, Input, OnInit} from '@angular/core';
import { Deal } from '../../core';
import AssetsUtil from '../../core/utils/assets.util';
import MiscUtil from '../../core/utils/misc.util';

@Injectable()
@Directive()
// eslint-disable-next-line @angular-eslint/directive-class-suffix
abstract class DealRelatedComponent implements OnInit {
    @Input() deal: Deal;
    oldPriceVisible: Boolean;
    savingVisible: Boolean;
    imageFallback = AssetsUtil.loadDealFallbackOnError();

    ngOnInit() {
        this.oldPriceVisible = (this.deal.link_list_price > this.deal.link_price && this.deal.link_list_price > 0);
        this.savingVisible = (this.deal.link_percent_off > 0);
    }
}

@Component({
    selector: 'app-deal-detail-related',
    templateUrl: './deal-related.component.html',
})
export class DealRelatedDetailsComponent extends DealRelatedComponent {}
